
export const validateStyleAttribute = (attribute) => {
  const errors = [];
  
  if (attribute.fontSize && (isNaN(attribute.fontSize) || attribute.fontSize <= 0)) {
    errors.push("El tamaño de fuente debe ser un número positivo");
  }

  return errors;
};

export const validateGlobalStyles = (styles) => {
  const errors = {};
  let isValid = true;

  Object.entries(styles).forEach(([key, value]) => {
    const attributeErrors = validateStyleAttribute(value);
    if (attributeErrors.length > 0) {
      errors[key] = attributeErrors;
      isValid = false;
    }
  });

  return { isValid, errors };
};

export const sanitizeStyleValue = (key, value) => {
  const sanitized = {};

  Object.keys(value).forEach(k => {
    if (value[k] !== null && value[k] !== undefined) {
      sanitized[k] = value[k];
    }
  });

  if (sanitized.fontSize) {
    const fs = Number(sanitized.fontSize);
    if (!isNaN(fs) && fs > 0) {
      sanitized.fontSize = fs;
    } else {
      delete sanitized.fontSize;
    }
  }
  
  if (sanitized.show === "true") sanitized.show = true;
  if (sanitized.show === "false") sanitized.show = false;

  return sanitized;
};
